export const imports = {
  'resources/gettingstarted.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "resources-gettingstarted" */ 'resources/gettingstarted.mdx'
    ),
  'resources/props.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "resources-props" */ 'resources/props.mdx'
    ),
  'resources/introduction.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "resources-introduction" */ 'resources/introduction.mdx'
    ),
}
